// 接口访问白名单 or 结果白名单
export default {
  RESPONSE_DIRECT_RETURN_ROUTERS: ['ProductMedia']
}
